import { render, staticRenderFns } from "./DiscountModal.vue?vue&type=template&id=2fda4ba6"
import script from "./DiscountModal.vue?vue&type=script&lang=js"
export * from "./DiscountModal.vue?vue&type=script&lang=js"
import style0 from "./DiscountModal.vue?vue&type=style&index=0&id=2fda4ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports